<template>
  <v-container>
    <div v-html="evaluation.task"></div>
    <br />
    <p>
      <span>Текстове завдання</span>
      <vue-editor v-model="answer" :editorToolbar="customToolbar"></vue-editor>
    </p>
    <div>
      <v-btn large color="primary" @click="sendAnswer">Відповісти</v-btn>
    </div>
  </v-container>
</template>

<script>
import evaluationEventEnum from '@/enums/evaluationEventEnum';
import { VueEditor } from 'vue2-editor';
export default {
  name: 'TaskEvaluation',
  components: { VueEditor },
  props: {
    evaluation: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      answer: this.evaluation.answer || '',
      //https://github.com/davidroyer/vue2-editor/blob/master/src/helpers/default-toolbar.js
      customToolbar: [
        [{ header: [false, 1, 2, 3, 4, 5, 6] }],
        ['bold', 'italic', 'underline', 'strike'], // toggled buttons
        [
          { align: '' },
          { align: 'center' },
          { align: 'right' },
          { align: 'justify' },
        ],
        ['blockquote', 'code-block'],
        [{ list: 'ordered' }, { list: 'bullet' }, { list: 'check' }],
        [{ indent: '-1' }, { indent: '+1' }], // outdent/indent
        [{ color: [] }, { background: [] }], // dropdown with defaults from theme
        ['link'], //'image', 'video'
        ['clean'], // remove formatting button
      ],
    };
  },
  watch: {
    evaluation(evaluation) {
      this.answer = evaluation.answer;
    },
  },

  methods: {
    sendAnswer() {
      this.$emit('evaluateEvent', {
        type: evaluationEventEnum.SEND_ANSWER,
        data: {
          answer: this.answer,
        },
      });
    },
  },
};
</script>
